import { useLocation } from 'react-router-dom';
import { useNavigate } from 'hooks/routes';
import {
  AssetsIcon_24,
  CalendarIcon_24,
  TradeIcon_24,
  TransactionsIcon_24,
} from 'assets/icons';
import { NavTabItem, NavTabsContainer } from 'components/NavTabs';

import messages from './EtzProfileNavTabs.messages';

const EtzProfileNavTabs = (): JSX.Element => {
  const { pathname } = useLocation();

  const {
    toEtzProfileTransactions,
    toEtzProfileAssets,
    toEtzProfileRevenueByMonth,
    toEtzProfileInflowOutflow,
  } = useNavigate();

  return (
    <NavTabsContainer>
      <NavTabItem
        onClick={toEtzProfileTransactions}
        isActive={pathname.includes('transactions')}
      >
        <TransactionsIcon_24 />
        {messages.transactions}
      </NavTabItem>

      <NavTabItem onClick={toEtzProfileAssets} isActive={pathname.includes('assets')}>
        <AssetsIcon_24 />
        {messages.assets}
      </NavTabItem>

      <NavTabItem
        onClick={toEtzProfileRevenueByMonth}
        isActive={pathname.includes('revenue')}
      >
        <CalendarIcon_24 />
        {messages.revenueByMonth}
      </NavTabItem>

      <NavTabItem
        onClick={toEtzProfileInflowOutflow}
        isActive={pathname.includes('inflow-outflow')}
      >
        <TradeIcon_24 />
        {messages.inflowOutflowByMonth}
      </NavTabItem>
    </NavTabsContainer>
  );
};

export default EtzProfileNavTabs;
